import {createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';

const initialState = {
    amazon: null,
    amazon_v2: null,
    paypal_v3: null,
    stripe_apple_pay: null,
    stripe_google_pay: null,
};

/**
 * Get payment amazon and payPal
 * @returns {ActionType<AxiosPromise>} Action
 */
export const getPayment = createAsyncThunk<{data: typeof initialState}>(
    'CART@GET_PAYMENT_BUTTONS',
    () =>
        apiConfig.instanceGusaBackend({
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
            },
            method: 'get',
            url: ENDPOINTS.CART_GET_PAYMENT_BUTTONS,
        }),
);

export const payments = createReducer(initialState, builder =>
    builder.addCase(getPayment.fulfilled, (state, action) => ({
        ...state,
        ...action?.payload?.data,
    })),
);
